/**
 * 
 * Just a timeout wrapped with a promise
 * The intent is to provide the projects + postings routes a promise that takes time to resolve
 * Returning this in the beforeModel/model/afterModel hooks will force the application level loading substate
 * Ideally return this from afterModel (especially if using AuthenticatedRouteMixin)
 * 
 * @param {Number} ms 
 */
export const timeout = (ms) => new Promise ((resolve) => {
  setTimeout(() => resolve(), ms);  
});
